import { QueryFactory } from "../../../../Common";
export const QGetLimitsHistory = QueryFactory("GetLimitsHistory");
//# sourceMappingURL=QGetLimitsHistory.js.map